// All reducers are here ONLY to be exported to ./rootReducer
export { routerReducer as routing } from 'react-router-redux';
export { default as units } from './units';
export { default as modal } from './modal';
export { default as notification } from './notification';
export { default as userState } from './user';
export { default as theoryLessons } from './theoryLessons';
export { default as drivingLessons } from './drivingLessons';
export { default as workItem } from './workItem';
export { default as general } from './general';
export { default as applicantLessonStatus } from './applicantsLessonStatus';
export { default as lessonsEdit } from './lessonsEdit';
export { default as lessonsReport } from './lessonsReport';
export { default as dataImport } from './dataImport';



// WEBPACK FOOTER //
// ./src/ducks/index.js